import api from '@/lib/api';

export interface Tag {
  id: string;
  name: string;
  color: string;
  description?: string;
  organization_id: string;
  created_by: string;
  created_by_email?: string;
  created_by_first_name?: string;
  created_by_last_name?: string;
  created_at: string;
  updated_at: string;
  is_active: boolean;
}

export interface CreateTagData {
  name: string;
  color?: string;
  description?: string;
}

export interface UpdateTagData {
  name?: string;
  color?: string;
  description?: string;
}

export interface TagsResponse {
  success: boolean;
  data: {
    tags: Tag[];
  };
}

export interface TagResponse {
  success: boolean;
  data: {
    tag: Tag;
  };
  message?: string;
}

class TagsService {
  async getTags(): Promise<TagsResponse> {
    const response = await api.get<TagsResponse>('/tags');
    return response.data;
  }

  async getTagById(id: string): Promise<TagResponse> {
    const response = await api.get<TagResponse>(`/tags/${id}`);
    return response.data;
  }

  async createTag(data: CreateTagData): Promise<TagResponse> {
    const response = await api.post<TagResponse>('/tags', data);
    return response.data;
  }

  async updateTag(id: string, data: UpdateTagData): Promise<TagResponse> {
    const response = await api.put<TagResponse>(`/tags/${id}`, data);
    return response.data;
  }

  async deleteTag(id: string): Promise<{ success: boolean; message: string }> {
    const response = await api.delete(`/tags/${id}`);
    return response.data;
  }
}

export default new TagsService();
